<template>
	<div
		class="ms-input flex ms-editor"
		:class="{ isValid: errorProvider.isValid, 'input-disabled': disabled }"
		v-tooltip="{ content: tooltipContent }"
	>
		<input
			class="ms-input-item"
			:placeholder="placeholder"
			v-model="internalText"
			:disabled="disabled"
			:readonly="readOnly"
			:maxlength="maxLength"
			ref="input"
			:class="{ 'input-disabled': disabled }"
			v-on="listeners"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: `error`,
				placement: placementTooltip,
			}"
			v-if="errorProvider.isValid"
		>
			<div class="mi mi-20 mi-icon-error"></div>
		</div>
		<div :class="['icon-input', 'mi', 'mi-24', icon]" v-if="icon"></div>
	</div>
</template>
<script>
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
export default {
	extends: msBaseComponent,
	name: 'msInput',
	props: {
		/**
		 * V-model bắn ra ngoài binding 2 chiều
		 */
		value: {
			default: null,
		},
		/**
		 * Hiện thị chũ mờ ở dưới ô input
		 * Created by LTDAT(22.06.2020)
		 */
		placeholder: {
			default: null,
			type: [Number, String],
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		//class chứa icon
		icon: {
			default: null,
			type: String,
		},
		//input chỉ đọc không cho nhập
		readOnly: {
			default: false,
			type: Boolean,
		},
		//Giới hạn nhập của ô input
		maxLength: {
			default: null,
			type: Number,
		},
		placementTooltip: {
			default: 'bottom',
			type: String,
		},
	},
	data() {
		return {
			internalText: this.value,
			focused: false,
			displayValue: null,
			scrollWidth: 0,
		};
	},
	created() {
		const me = this;
	},
	computed: {
		listeners() {
			return {
				blur: (e) => {
					this.onBlur(e);
				},
				focus: (e) => {
					this.onFocus(e);
				},
				change: (e) => {
					this.$emit('change', this.internalText, e);
				},
				keydown: (e) => {
					this.$emit('keydown', e);
				},
			};
		},
		tooltipContent() {
			const me = this;
			let text = me.internalText ? me.internalText.trim() : '';
			if (!text) {
				return null;
			}
			return me.hasTooltip() ? me.internalText : null;
		},
		// hasTooltip() {
		// 	const me = this;
		// 	if (me.$refs.input && me.scrollWidth > me.$refs.input.offsetWidth) {
		// 		return true;
		// 	}
		// 	return false;
		// }
	},
	methods: {
		hasTooltip() {
			const me = this;
			if (me.$refs.input && me.scrollWidth > me.$refs.input.offsetWidth) {
				return true;
			}
			return false;
		},
		//Sự kiện focus vào ô input
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiên blur ra ngoài ô input
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		},
		//Reset lại giá trị về ban đầu
		reset() {
			const me = this;
			me.internalText = null;
			me.displayValue = null;
		},
		//Set giá trị cho ô input
		setValue(value) {
			const me = this;
			if (me.rules) {
				let listRules = me.rules.split('|');
				if (value && listRules.includes('phone')) {
					value = value.replace(/ /g, '').replace(/\./g, '');
				}
			}
			me.internalText = value;
		},
	},
	watch: {
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				me.$emit('input', newVal);
				me.$nextTick(() => {
					me.errorProvider = {};
					this.validate();
				});
				me.scrollWidth = me.$refs.input.scrollWidth;
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setValue(newVal);
			},
		},
		disabled: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.validate();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msInput.scss';
}
</style>

